/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".nuget-version-container[_ngcontent-%COMP%]{padding:20px 0}.nuget-version-container[_ngcontent-%COMP%]:last-child{border-bottom:0}"];
export { styles as styles };
